import api from './api'
import {
	fixtureFetchStudentEssays,
	shouldUseApplicationFlowFixtures,
} from 'fixtures/applicationFlowFixtures'

export const fetchPendingReviewEssays = ({ limit } = {}) =>
	api.get('/counseling/dashboard/essays-pending-review', {
		params: {
			limit: Number.isFinite(Number(limit)) ? Number(limit) : undefined,
		},
	})

export const fetchPendingFeedbackReplies = ({ limit } = {}) =>
	api.get('/counseling/dashboard/feedback-pending', {
		params: {
			limit: Number.isFinite(Number(limit)) ? Number(limit) : undefined,
		},
	})

export const markEssayVersionSeen = (versionId, { anchorAt } = {}) =>
	api.post(
		`/counseling/dashboard/essay-versions/${encodeURIComponent(versionId)}/seen`,
		{ anchor_at: anchorAt || undefined },
	)

export const markFeedbackVersionSeen = (versionId, { anchorAt } = {}) =>
	api.post(
		`/counseling/dashboard/feedback-versions/${encodeURIComponent(versionId)}/seen`,
		{ anchor_at: anchorAt || undefined },
	)

export const fetchStudentEssays = ({ studentId, universityId }) =>
	shouldUseApplicationFlowFixtures()
		? Promise.resolve(fixtureFetchStudentEssays({ studentId, universityId }))
		: api.get(`/counseling/students/${encodeURIComponent(studentId)}/essays`, {
				params: {
					university_id: universityId || undefined,
				},
		  })

export const fetchEssayVersions = (essayId, { includeDrafts = true } = {}) =>
	api.get(`/counseling/essays/${encodeURIComponent(essayId)}/versions`, {
		params: { include_drafts: includeDrafts ? 'true' : 'false' },
	})

export const fetchEssayVersionsMetadata = (
	essayId,
	{ includeDrafts = true } = {},
) =>
	api.get(`/counseling/essays/${encodeURIComponent(essayId)}/versions`, {
		params: {
			include_drafts: includeDrafts ? 'true' : 'false',
			metadata_only: 'true',
		},
	})

export const fetchVersionChatMessages = (essayId, versionId) =>
	api.get(
		`/counseling/essays/${encodeURIComponent(essayId)}/versions/${encodeURIComponent(versionId)}/chat/messages`,
	)

export const postVersionChatMessage = (essayId, versionId, body) =>
	api.post(
		`/counseling/essays/${encodeURIComponent(essayId)}/versions/${encodeURIComponent(versionId)}/chat/messages`,
		body,
	)

export const patchVersionChatReadForCounselor = (essayId, versionId) =>
	api.patch(
		`/counseling/essays/${encodeURIComponent(essayId)}/versions/${encodeURIComponent(versionId)}/chat/read`,
		{},
	)

export const patchEssayThreadDeadline = (essayId, essayDeadlineAt) =>
	api.patch(`/counseling/essays/${encodeURIComponent(essayId)}`, {
		essay_deadline_at: essayDeadlineAt,
	})

export const patchEssayVersion = (essayId, versionId, body) =>
	api.patch(
		`/counseling/essays/${encodeURIComponent(essayId)}/versions/${encodeURIComponent(versionId)}`,
		body,
	)

export const patchVersionChatMessageStatus = (essayId, versionId, messageId, body) =>
	api.patch(
		`/counseling/essays/${encodeURIComponent(essayId)}/versions/${encodeURIComponent(versionId)}/chat/messages/${encodeURIComponent(messageId)}`,
		body,
	)

export const resolveAllVersionFeedbacks = (essayId, versionId) =>
	api.patch(
		`/counseling/essays/${encodeURIComponent(essayId)}/versions/${encodeURIComponent(versionId)}/chat/resolve-all`,
		{},
	)
